// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jQ91","badges":"styles_badges__8ID-n"};